export const teoriaContratosYEstandares = [
    {
      title: "¿Qué son los contratos inteligentes y los estándares de tokens en Ethereum?",
      value: `
  Un **contrato inteligente** (smart contract) es un programa autoejecutable que vive en una blockchain como Ethereum.  
  Se compone de reglas y condiciones que se cumplen automáticamente: cuando ocurre una acción válida, el contrato se ejecuta sin intervención humana.  
  Esto permite crear aplicaciones descentralizadas, automatizar pagos, gestionar membresías, realizar votaciones, emitir activos y mucho más.
  
  ---
  
  ### ¿Qué es el estándar ERC20?
  
  El **ERC20** es el estándar más popular para crear **tokens fungibles** en Ethereum.  
  Un token fungible es aquel donde cada unidad es idéntica a otra, como una moneda: 1 token = 1 token.
  
  **Ventajas del estándar ERC20:**
  - Garantiza compatibilidad con wallets, exchanges y contratos DeFi.
  - Facilita transferencias, aprobaciones y consultas de saldo.
  - Permite crear criptomonedas, puntos, utilidades o activos digitales intercambiables.
  
  ---
  
  ### Otros estándares populares de Ethereum y sus usos
  
  A lo largo del tiempo, la comunidad ha creado diferentes estándares (con el prefijo “ERC” para Ethereum Request for Comments) para cubrir distintas necesidades de la blockchain:
  
  #### ERC20 — **Tokens Fungibles**
  - **Uso:** Criptomonedas, stablecoins, utilidades, puntos de lealtad, activos digitales.
  - **Ejemplos:** USDT, USDC, DAI, LINK, UNI.
  
  #### ERC721 — **Tokens No Fungibles (NFTs)**
  - **Uso:** Activos únicos y coleccionables digitales (arte, juegos, certificados).
  - **Ejemplo:** Cada token es único y no intercambiable por otro.
  - **Ejemplos:** CryptoKitties, Bored Ape Yacht Club.
  
  #### ERC1155 — **Tokens Múltiples (Semi-fungibles)**
  - **Uso:** Permite gestionar **varios tipos de tokens** (fungibles y no fungibles) en un solo contrato.
  - **Ideal para:** Videojuegos, marketplaces, plataformas con diferentes activos y coleccionables.
  - **Ejemplo:** En un juego, puedes tener una espada (NFT) y monedas (ERC20) bajo un solo contrato ERC1155.
  
  #### ERC777 — **Mejora sobre ERC20**
  - **Uso:** Añade funciones avanzadas para interoperabilidad y “hooks” (acciones automáticas en transferencias).
  - **Ventaja:** Mejora la interacción entre contratos y la seguridad de transferencias complejas.
  
  #### ERC4626 — **Vault Standard**
  - **Uso:** Estándar para bóvedas de rendimiento en DeFi (para gestionar depósitos y ganancias sobre activos).
  - **Ejemplo:** Plataformas DeFi donde los usuarios depositan tokens para ganar intereses de forma estandarizada.
  
  #### Otros estándares útiles:
  - **ERC223** — Mejoras en seguridad para transferencias de tokens (no tan adoptado).
  - **ERC827** — Añade permisos extra a ERC20.
  - **ERC998** — NFTs compuestos (un NFT puede poseer otros NFTs o tokens ERC20).
  
  ---
  
  ### ¿Por qué existen estos estándares?
  
  Cada estándar **asegura que los contratos y aplicaciones sean compatibles entre sí**.  
  Esto permite que wallets, exchanges y plataformas reconozcan y soporten cualquier token, NFT o activo digital creado bajo estas reglas, asegurando interoperabilidad y crecimiento en el ecosistema Ethereum.
  
  ---
  
  **Resumen:**  
  - Los **contratos inteligentes** permiten automatizar reglas y procesos en blockchain.
  - El **ERC20** es el estándar principal para tokens intercambiables.
  - Existen muchos otros estándares como **ERC721 (NFTs)** y **ERC1155 (multi-activos)**, cada uno con un uso y ventaja diferente según la aplicación.
  
  En las siguientes secciones aprenderás a editar, personalizar y desplegar tu propio contrato inteligente según el estándar que más se adapte a tu proyecto.
  `
    }
  ];
  
  export default teoriaContratosYEstandares;
  